<!--全局的下拉菜单-->
<template>
  <div class="el-select-wrapper">
    <i slot="prefix" class="el-input__icon el-icon-search" v-if="hasSearchIcon"></i>
    <el-select
      v-model="currentValue"
      :disabled="disabled"
      :filterable="filterable"
      :placeholder="placeholder"
      v-bind="$attrs"
      @change="handleChange"
    >
      <el-option
        v-for="(item) in data"
        :key="item[keyValue[0]]"
        :label="item[keyValue[1]]"
        :disabled="item.disabled"
        :value="item[keyValue[0]]"
      >
        <slot name="ny:item" v-bind="item"></slot>
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'NySelect',
  props: {
    value: {
      required: true
    },
    type: String,
    data: {
      type: Array,
      required: true,
      default: function () {
        return [];
      }
    },
    filterable: Boolean,
    disabled: Boolean,
    placeholder: {
      type: String,
      default: '请选择'
    },
    keyValue: {
      type: Array,
      default () {
        return ['value', 'name'];
      }
    },
    hasSearchIcon: Boolean
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  methods: {
    handleChange (value) {
      this.$emit('input', value)
      this.$emit('change', {
        value,
        type: this.type
      })
    }
  },
  watch: {
    value (newVal) {
      this.currentValue = newVal;
    }
  }
};
</script>

<style>
.el-select-wrapper {
  position: relative;
  display: inline-block;
}

.el-select-wrapper .el-icon-search {
  position: absolute;
  left: 0;
  z-index: 1;
}

.el-form-item.has-search-icon .el-select-wrapper .el-icon-search {
  left: 0px;
}

.el-form-item .el-select-wrapper .el-icon-search {
  left: 16px;
}

.el-select-wrapper .el-icon-search:before {
  color: #e21d25;
}

.el-select .el-input .el-input__icon + .el-input__inner {
  padding: 0 30px 0 30px;
}
</style>
